<template>
  <div class="list-group">
    <li
      :class="`list-group-item nx-player-list-item mobile d-flex justify-content-between align-items-center p-1 ${
        $root.enablePlayerStateModal(flight) ? 'clickable' : ''
      }`"
      :style="{
        backgroundColor: player.backgroundColor,
        color: player.foregroundColor,
      }"
      v-for="(player, playerIndex) in flight.players"
      :key="playerIndex"
      @click="onClick($event, flight, player)"
    >
      <div class="ms-2 me-auto">
        <div class="fw-bold">{{ player.player }}</div>
        {{ playerHomeClub(player) }}
      </div>
      <span
        v-if="player.arrived || player.noshow"
        :style="{
          color: player.foregroundColor,
        }"
        ><i
          :class="`bi ${player.arrived ? 'bi-check-lg' : ''} ${
            player.noshow ? 'bi-x' : ''
          }`"
        ></i>
      </span>
    </li>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  props: {
    flight: Object,
    onClick: Function,
  },
  computed: {
    ...mapGetters({
      showHomeClub: "navigation/getShowHomeClub",
    }),
  },
  components: {},
  methods: {
    playerHomeClub(player) {
      if (this.showHomeClub == false) {
        return "";
      }
      return player.homeclub ?? "";
    },
  },
});
</script>
